@if (report) {
	<div>
		<div class="title">Class Breakdown</div>
		<div class="class-breakdown-header">
			<div>Level</div>
			@for (skill of sortedSkills; track skill) {
				<div>{{ skill.label }}</div>
			}
			<div>Composite</div>
		</div>
		<div class="class-breakdown-levels">
			@for (level of report.classBreakdown; track level) {
				<div class="class-breakdown-level" [ngClass]="'level' + level.rubricLevel.level + '-color'">
					<div class="level-name">
						<div class="color-bar"></div>
						<span>
							{{ level.rubricLevel.name }}
						</span>
					</div>
					@for (skill of sortedSkills; track skill) {
						<div [ngClass]="skill.code">
							<!-- Percentage Bar -->
							<div
								class="percentage-bar"
								[style.width.%]="
									skill.code === 'reading'
										? level.readingPercentage
										: skill.code === 'writing'
											? level.writingPercentage
											: skill.code === 'speaking'
												? level.speakingPercentage
												: skill.code === 'listening'
													? level.listeningPercentage
													: 0
								"
							></div>
							<!-- Count -->
							<span>
								{{
									skill.code === 'reading'
										? level.readingCount
										: skill.code === 'writing'
											? level.writingCount
											: skill.code === 'speaking'
												? level.speakingCount
												: skill.code === 'listening'
													? level.listeningCount
													: 0
								}}
								/ {{ report.students.length }}
							</span>
						</div>
					}
					<div class="composite">
						<div class="percentage-bar" [style.width]="level.compositePercentage + '%'"></div>
						<span>{{ level.compositeCount }} / {{ report.students.length }}</span>
					</div>
				</div>
			}
			<div class="class-average">
				<div class="level-name">
					<span>Class Average</span>
				</div>
				<div class="reading">
					<span>{{ (report.classAverage['reading'] || 0).toFixed(2) }}</span>
				</div>
				<div class="writing">
					<span>{{ (report.classAverage['writing'] || 0).toFixed(2) }}</span>
				</div>
				<div class="listening">
					<span>{{ (report.classAverage['listening'] || 0).toFixed(2) }}</span>
				</div>
				<div class="speaking">
					<span>{{ (report.classAverage['speaking'] || 0).toFixed(2) }}</span>
				</div>
				<div class="composite">
					<span>{{ (report.classAverage['composite'] || 0).toFixed(2) }}</span>
				</div>
			</div>
		</div>
	</div>
}
